import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Global/Layout/Layout';
import { Col, Row } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import styles from '../components/Page-CSS/productCategoriesTemplate.module.css';
import ProductSnippet from '../components/Global/ProductSnippet/ProductSnippet';
import * as _ from 'lodash';
import SlideShow from '../components/Global/SlideShow/SlideShow';
import SEO from '../components/Global/SEO';

const ProductCategoriesTemplate = ({ data }) => {
	const {
		shopifyCollection: {
			title,
			description,
			products,
			image: { localFile: { childImageSharp: { fluid: { src } } } }
		}
	} = data;
	const { nodes } = data.allShopifyCollection;

	const [ initialProducts, setInitialProducts ] = useState(products);
	const [ sizeInput, setSizeInput ] = useState('all');
	const [ colorInput, setColorInput ] = useState('all');
	const [ order, setOrder ] = useState('asc');

	const collectionArrayWithoutCurrentCollection = nodes.filter((collection) => collection.title !== title);

	const handleOrder = () => {
		const array = [];
		initialProducts.forEach((product) =>
			array.push({
				title: product.title,
				handle: product.handle,
				price: Number(product.priceRange.minVariantPrice.amount),
				images: product.images,
				options: product.options,
				variants: product.variants
			})
		);

		let newArray = [];

		if (order === 'desc') {
			newArray = array.sort((a, b) => (a.price > b.price ? -1 : 1));
		} else if (order === 'asc') {
			newArray = array.sort((a, b) => (a.price > b.price ? 1 : -1));
		}

		return (
			<Row className={styles.productHolder}>
				{newArray.length !== 0 ? (
					newArray.map((product) => (
						<ProductSnippet
							src={product.images[0].localFile.childImageSharp.fluid}
							title={product.title}
							price={product.price}
							handle={`${product.handle}`}
							key={uuidv4()}
						/>
					))
				) : (
					<Col xs={12}>
						<Row className={styles.removeFilterTextHolder}>
							<Col xs={10} sm={8}>
								<p className={styles.removeFilterText}>
									Hmm, we appear to not have any products that match your description (yet{' '}
									<span role="img" aria-label="wink face emoji">
										😉
									</span>). Maybe try relaxing the filters?
								</p>
								<button onClick={() => clearFilter()} className={styles.button}>
									Clear filters
								</button>
							</Col>
						</Row>
					</Col>
				)}
			</Row>
		);
	};

	const showSizes = () => {
		const sizesArray = [];
		const sizesArray2 = [];

		const allSizes = products.map((product) => product.options.filter((option) => option.name === 'Size'));

		allSizes.forEach((size) => sizesArray.push(size[0].values));

		sizesArray.forEach((array) =>
			array.forEach((item) => (sizesArray2.includes(item) ? null : sizesArray2.push(item)))
		);

		const finalSizeArray = sizesArray2.map((i) => Number(i));

		const sortedArray = finalSizeArray.sort((a, b) => a - b);

		return (
			<Col xs={3} md={3} className={styles.size}>
				<label htmlFor="size">Size</label>
				<select
					name="size"
					id="size"
					value={sizeInput}
					onChange={(e) => setSizeInput(e.target.value)}
					className={styles.select}
				>
					<option value="all">All</option>)
					{sortedArray.map((size) => (
						<option value={size} key={uuidv4()}>
							{size}
						</option>
					))}
				</select>
			</Col>
		);
	};

	const showColors = () => {
		const colorArray = [];
		const colorArray2 = [];

		const allColors = products.map((product) => product.options.filter((option) => option.name === 'Color'));

		allColors.forEach((color) => colorArray.push(color[0].values));

		colorArray.forEach((array) =>
			array.forEach((item) => (colorArray2.includes(item) ? null : colorArray2.push(item)))
		);

		return (
			<Col xs={5} sm={6} md={4}>
				<label htmlFor="color">Color</label>
				<select
					name="color"
					id="color"
					value={colorInput}
					onChange={(e) => setColorInput(e.target.value)}
					className={styles.select}
				>
					<option value="all">All</option>)
					{colorArray2.map((color) => (
						<option value={color} key={uuidv4()}>
							{color}
						</option>
					))}
				</select>
			</Col>
		);
	};

	const filterByColor = (color, size) => {
		if (color === 'all' && size === 'all') {
			setInitialProducts(products);
		} else if (size !== 'all' && color === 'all') {
			const productsAfterFilter = [];

			products.forEach((product) =>
				product.variants.forEach(
					(item) => (item.title.includes(size) ? productsAfterFilter.push(product) : null)
				)
			);

			const productsAfterFilterWithoutDuplicates = _.uniqBy(productsAfterFilter, 'title');
			setInitialProducts(productsAfterFilterWithoutDuplicates);
		} else if (size === 'all' && color !== 'all') {
			const productsAfterFilter = [];

			products.forEach((product) =>
				product.variants.forEach(
					(item) => (item.title.includes(color) ? productsAfterFilter.push(product) : null)
				)
			);

			const productsAfterFilterWithoutDuplicates = _.uniqBy(productsAfterFilter, 'title');
			setInitialProducts(productsAfterFilterWithoutDuplicates);
		} else {
			const productsAfterFilter = [];

			products.forEach((product) =>
				product.variants.forEach(
					(item) => (item.title.includes(color) ? productsAfterFilter.push(product) : null)
				)
			);

			const productsAfterFilterWithoutDuplicates = _.uniqBy(productsAfterFilter, 'title');

			const arrayAfterSizeFilter = [];

			productsAfterFilterWithoutDuplicates.forEach(
				(item) => (item.options[0].values.includes(size) ? arrayAfterSizeFilter.push(item) : null)
			);

			setInitialProducts(arrayAfterSizeFilter);
		}
	};

	useEffect(
		() => {
			filterByColor(colorInput, sizeInput);

			handleOrder();
		},
		[ colorInput, sizeInput ]
	);

	const clearFilter = () => {
		setInitialProducts(products);
		setSizeInput('all');
		setColorInput('all');
	};

	return (
		<Layout>
			<SEO title={title} description={description} image={src} />
			<Row>
				<Col xs={12}>
					<Row className={styles.descriptionHolder}>
						<Col xs={12} sm={6} className={styles.description}>
							<h1>{title}</h1>
							<p>{description}</p>
						</Col>
					</Row>
					<Row className={styles.filters}>
						<Col xs={3} md={6}>
							<Row className={styles.filterRowOne}>
								{showSizes()}
								{showColors()}
							</Row>
						</Col>

						<Col xs={6} md={6} className={styles.priceFilter}>
							<Row className={styles.filterRowTwo}>
								<Col xs={10} md={10} lg={12}>
									<label htmlFor="price">Order by Price</label>
									<select
										id="price"
										onChange={(e) => setOrder(e.target.value)}
										className={styles.priceSelect}
									>
										<option value="asc">Asc</option>
										<option value="desc">Desc</option>
									</select>
								</Col>
							</Row>
						</Col>
					</Row>
					{handleOrder()}
				</Col>
				<Col xs={12} className={styles.SlideShow}>
					<SlideShow
						products={collectionArrayWithoutCurrentCollection}
						title="YOU MIGHT ALSO LIKE"
						bgColor="white"
					/>
				</Col>
			</Row>
		</Layout>
	);
};

export default ProductCategoriesTemplate;

export const query = graphql`
	query($handle: String!) {
		shopifyCollection(handle: { eq: $handle }) {
			title
			description
			handle
			image {
				localFile {
					childImageSharp {
						fluid {
							src
						}
					}
				}
			}
			products {
				title
				handle
				options {
					values
					name
				}
				variants {
					title
				}
				priceRange {
					minVariantPrice {
						amount
					}
				}
				images {
					id
					localFile {
						childImageSharp {
							fluid {
								...GatsbyImageSharpFluid
							}
						}
					}
				}
			}
		}
		allShopifyCollection {
			nodes {
				title
				handle
				image {
					localFile {
						childImageSharp {
							fluid(maxWidth: 800, maxHeight: 800) {
								...GatsbyImageSharpFluid
							}
						}
						name
					}
				}
			}
		}
	}
`;
